import { createAction } from '@reduxjs/toolkit';
export const REMOVE_ANALYTIC_TEAM_MEMBER = 'REMOVE_ANALYTIC_TEAM_MEMBER';
export const removeAnalyticTeamMemberAction = createAction(REMOVE_ANALYTIC_TEAM_MEMBER);